import {
   type CountryCode,
   type LanguageCode,
   ShopifyStorefrontProvider,
} from '@ifixit/shopify-storefront-client';
import { initializeChakraComponent } from 'Shared/chakra-initialize';
import { ComponentData, GuideProducts } from './GuideProducts';
import { GuideData, GuideHeading } from './GuideHeader';
import { withGuideSubscription } from './GuideSubscription';
import { withGuideFavorite } from './GuideFavorite';
import { withGuideCompletion } from './GuideComplete';
import { ReactNode } from 'react';
import { FullWidthFlags } from './FullWidthFlags';
import type { RepairShopLocatorProps } from './repair-shop-locator';

type GuideTopProps = ComponentData & {
   guideData?: GuideData;
   repairShopLocatorData: RepairShopLocatorProps;
   shopifyStore: {
      country: CountryCode;
      currencyCode: string;
      language: LanguageCode;
      storeCode: string;
      shopDomain: string;
      storefrontAccessToken: string;
   };
   user: {
      priceTiers: Record<string, string>;
   } | null;
};

function GuideMicrodata({ guideData, children }: { guideData: GuideData; children: ReactNode }) {
   return (
      <div itemScope itemType="http://schema.org/HowTo" itemRef="steps-container">
         <meta itemProp="name" content={guideData.title} />

         <div itemProp="author" itemScope itemType="http://schema.org/Person">
            <meta itemProp="url" content={guideData.author.url} />
            <meta itemProp="name" content={guideData.author.name} />
            <meta itemProp="image" content={guideData.author.image} />
         </div>

         <meta itemProp="datePublished" content={guideData.published_date} />
         <meta itemProp="dateModified" content={guideData.modified_date} />

         <div itemProp="image" itemScope itemType="http://schema.org/ImageObject">
            <meta itemProp="url" content={guideData.mainImage} />
            <meta itemProp="width" content={guideData.mainImageWidth} />
            <meta itemProp="height" content={guideData.mainImageHeight} />
         </div>

         <meta
            itemProp="commentCount"
            content={(guideData.guideCommentCount + guideData.stepCommentCount).toString()}
         />
         <meta itemProp="totalTime" content={guideData.totalTimeIso} />
         {children}
      </div>
   );
}

export function GuideTop(props: GuideTopProps) {
   const { guideData, shopifyStore } = props;
   if (!guideData) {
      return (
         <ShopifyStorefrontProvider {...shopifyStore}>
            <GuideProducts {...props} />
         </ShopifyStorefrontProvider>
      );
   }

   if (guideData.isTeardown) {
      return (
         <ShopifyStorefrontProvider {...shopifyStore}>
            {/* @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'. */}
            <FullWidthFlags flags={props.guideData.flags} />
            <GuideProducts {...props} />
         </ShopifyStorefrontProvider>
      );
   }

   return (
      <ShopifyStorefrontProvider {...shopifyStore}>
         <div id="guide-intro" style={{ maxWidth: '100vw' }}>
            <div className="actionbar-portal"></div>
            {/* @ts-expect-error TS(2322) FIXME: Type 'GuideData | undefined' is not assignable to ... Remove this comment to see the full error message */}
            <GuideMicrodata guideData={props.guideData}>
               {/* @ts-expect-error TS(2322) FIXME: Type '{ title?: string | undefined; mainImage?: st... Remove this comment to see the full error message */}
               <GuideHeading {...props.guideData} />
               {/* @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'. */}
               <FullWidthFlags flags={props.guideData.flags} />
               <GuideProducts {...props} />
            </GuideMicrodata>
         </div>
      </ShopifyStorefrontProvider>
   );
}

initializeChakraComponent(
   'GuideTopComponent',
   withGuideCompletion(withGuideSubscription(withGuideFavorite(GuideTop)))
);
